/**
 * SortableTh — a sortable column header (docs/DUPLICATION_AUDIT.md, B24; fixes A24's
 * table bullets).
 *
 * The Alerts, demo, corporate dashboard, billing and Caregiver tables sorted by clicking
 * the <th> itself, which a keyboard cannot reach and a screen reader does not announce
 * as a control. This puts a real <button> inside the header and sets `aria-sort`. The
 * label and the sort arrow are the caller's children, unchanged, so each table keeps its
 * own look.
 *
 *   <SortableTh sortKey="area_name" sortColumn={sortColumn} sortOrder={sortOrder}
 *               onSort={onSort} className="dp-th">Area{sortIcon('area_name')}</SortableTh>
 *
 * Tables whose header already holds a sort button only need `ariaSort` on the <th>.
 */

import './sortable-th.css';

/** The <th>'s aria-sort for a column: ascending / descending when sorted by it, else none. */
export function ariaSort(sortColumn, sortOrder, key) {
    if (sortColumn !== key) return 'none';
    return String(sortOrder).toLowerCase().startsWith('asc') ? 'ascending' : 'descending';
}

const SortableTh = ({ sortKey, sortColumn, sortOrder, onSort, className, style, title, children }) => (
    <th
        className={className}
        style={style}
        title={title}
        scope="col"
        aria-sort={ariaSort(sortColumn, sortOrder, sortKey)}
    >
        <button type="button" className="sortable-th__btn" onClick={() => onSort?.(sortKey)}>
            {children}
        </button>
    </th>
);

export default SortableTh;
